import { useEffectiveExperience } from '@/features/experiences/contexts/PageExperienceContext';
import { useCreateCategory } from '../hooks/useCreateCategory';
import { useDeleteCategory } from '../hooks/useDeleteCategory';
import { useUpdateCategory } from '../hooks/useUpdateCategory';
import { useUpdateCategorySortOrder } from '../hooks/useUpdateCategorySortOrder';
import {
  CategoryDataContext,
  type CategoryData,
} from './CategorySelect/CategoryDataContext';

type Props = {
  children: React.ReactNode;
};

export const CategoryProvider = ({ children }: Props) => {
  const experience = useEffectiveExperience();
  const { createCategory, isPending } = useCreateCategory();
  const { updateCategory } = useUpdateCategory();
  const { removeCategory, isPending: isRemovePending } = useDeleteCategory();
  const { updateSortOrder } = useUpdateCategorySortOrder();

  const value: CategoryData = {
    categories: experience.categories,
    createCategory,
    isCreatePending: isPending,
    updateCategory,
    removeCategory,
    isRemovePending,
    updateSortOrder,
  };

  return (
    <CategoryDataContext.Provider value={value}>
      {children}
    </CategoryDataContext.Provider>
  );
};
